import type {
  GetSocialIntegrationsResponse,
  HistoryUploadPeriod,
  ModelAddIntegrationResponse,
  ModelSocialIntegration,
} from '@app/api/SocialIntegrations';

import type { FormInstance } from 'antd';
import type { DefaultOptionType } from 'antd/es/select';

export type EmailModalFormValues = {
  SocialIntegrationName: string | null;
  AccountLogin: string | null;
  Password: string | null;
  Server: string | null;
  Port: number | null;
  IsSsl: boolean | null;
  salesFunnel: number | null;
  salesFunnelStage: number | null;
  ParseUsingNeural: boolean;
};

export type MessengerModalFormValues = {
  newName: string;
  salesFunnel: number | null;
  salesFunnelStage: number | null;
  token: string;
  phoneNumbersSelector: PhoneModes;
  operators: Array<number>;
  SignatureKey: string;
  AtcUniqCode: string;
  VirtualAtcApiAddress: string;
};

export type AddInstagramIntegrationModalProps = {
  getListData: () => Promise<GetSocialIntegrationsResponse | undefined>;
  salesFunnelsStages: Array<DefaultOptionType>;
  salesFunnels: Array<DefaultOptionType>;
  setSelectedSalesFunnelId: (value: number | null) => void;
  createHubConnection: (newIntegration?: ModelAddIntegrationResponse) => void;
  /**
   * Передаёт созданную WhatsApp-интеграцию в единую сессию авторизации: она
   * сама опрашивает состояние, обновляет код и показывает успех (issue/11029).
   */
  openWhatsAppAuthorization: (created: ModelAddIntegrationResponse) => void;
  setInitialSalesFunnel: () => number | undefined;
  editableIntegration: ModelSocialIntegration | undefined;
  setEditableIntegration: (value: ModelSocialIntegration | undefined) => void;
  openConnectAuth: (
    channelType: string,
    integrationId: number,
    authUrl?: string | null
  ) => void;
};

export type AddAtcModalProps = {
  setInitialSalesFunnel: () => number | undefined;
  setSelectedSalesFunnelId: (value: number | null) => void;
  salesFunnels: Array<DefaultOptionType>;
  salesFunnelsStages: Array<DefaultOptionType>;
  getData: () => Promise<GetSocialIntegrationsResponse | undefined>;
  editableIntegration: ModelSocialIntegration | undefined;
  token: string | null;
  setToken: React.Dispatch<React.SetStateAction<string | null>>;
};

export type SalesFunnels = {
  value: number;
  label: string | null;
};

export type AddInstagramIntegrationModalForm = {
  Name: string | undefined;
  HistoryUploadPeriod: HistoryUploadPeriod;
  salesFunnel: number;
  salesFunnelStage: number;
  operators?: Array<number>;
};

export type AddAtcModalForm = {
  Name: string;
  HistoryUploadPeriod: number;
  salesFunnel: number;
  salesFunnelStage: number;
  Token: string;
  phoneNumbersSelector: PhoneModes;
};

export type InstagramIntegrationFrameModalProps = {
  currentAuthLink: string;
};

export type EditMessengerModalProps = {
  isEditMessengerModalOpen: boolean;
  setIsEditMessengerModalOpen: (value: boolean) => void;
  setEditableIntegration: (value: ModelSocialIntegration | undefined) => void;
  salesFunnels: Array<DefaultOptionType>;
  salesFunnelsStages: Array<DefaultOptionType>;
  editIntegrationForm: FormInstance<MessengerModalFormValues>;
  setSelectedSalesFunnelId: (value: number | null) => void;
  editableIntegration: ModelSocialIntegration | undefined;
  getData: () => Promise<GetSocialIntegrationsResponse | undefined>;
  token: string | null;
  setToken: React.Dispatch<React.SetStateAction<string | null>>;
};

export enum PhoneModes {
  ALL = 'all',
  SELECTED = 'selected',
}
